import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

/**
 * Componente de notificación toast
 */
const NotificationToast = ({ notification, onClose }) => {
  if (!notification) return null;

  const { message, type } = notification;

  const getIconAndColors = () => {
    switch (type) {
      case 'success':
        return {
          icon: faCheckCircle,
          bgColor: 'bg-green-500',
          textColor: 'text-white',
          borderColor: 'border-green-400'
        };
      case 'error':
        return {
          icon: faExclamationTriangle,
          bgColor: 'bg-red-500',
          textColor: 'text-white',
          borderColor: 'border-red-400'
        };
      default:
        return {
          icon: faCheckCircle,
          bgColor: 'bg-blue-500',
          textColor: 'text-white',
          borderColor: 'border-blue-400'
        };
    }
  };

  const { icon, bgColor, textColor, borderColor } = getIconAndColors();

  return (
    <div className={`fixed top-4 right-0.5 sm:right-4 z-[100] max-w-md w-full mx-auto`}>
      <div className={`${bgColor} ${borderColor} border-l-4 p-4 rounded-md shadow-lg transform transition-all duration-300 ease-in-out`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <FontAwesomeIcon 
              icon={icon} 
              className={`${textColor} mr-3 text-lg`} 
            />
            <p className={`${textColor} text-sm font-medium`}>
              {message}
            </p>
          </div>
          
          <button 
            onClick={onClose}
            className={`${textColor} hover:opacity-70 transition-opacity`}
          >
            <FontAwesomeIcon icon={faTimes} className="text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationToast;